import { Component, OnInit, ViewChild } from '@angular/core';
import { Customer, License } from '../../customers.model';
import { HasPermissions } from '../../../../core/services/permissions/permissions.model';
import { Permissions } from '../../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../../core/services/permissions/permissions.service';
import { CustomersRest } from '../../customers.rest';
import { LicenseModalComponent } from './licenses-creation/license-modal.component';
import { GridComponent } from '../../../../core/shared/grid/grid.component';

@Component({
  selector: 'app-customer-licenses',
  templateUrl: './customer-licenses.component.html',
  styleUrls: ['./customer-licenses.component.scss']
})
export class CustomerLicensesComponent implements OnInit, HasPermissions {

  public customer: Customer;
  permissions: Permissions;
  @ViewChild(LicenseModalComponent) public licenseModal: LicenseModalComponent;
  @ViewChild(GridComponent) public grid: GridComponent;

  public headers = [
    { displayName: 'Nazwa dodatku', propertyName: 'appName', propertyType: 'string' },
    { displayName: 'Guid', propertyName: 'guid', propertyType: 'string' },
    { displayName: 'Od', propertyName: 'startDate', propertyType: 'date' },
    { displayName: 'Do', propertyName: 'expirationDate', propertyType: 'date' },
    { displayName: 'Częstotliwość', propertyName: 'checkFrequency', propertyType: 'number' },
    { displayName: 'Sprawdzono', propertyName: 'lastCheckDate', propertyType: 'date' },    
    { displayName: 'Ip', propertyName: 'ipAddress', propertyType: 'string' },
    { displayName: 'Info', propertyName: 'information', propertyType: 'string' }
  ];

  constructor(private rest: CustomersRest,
    private permissionService: PermissionsService) { }

  ngOnInit() {

  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  public getActionButtons() {
    return [];
  }

  public setModel(customer: Customer) {
    this.customer = customer;
    this.setPermissions('Customer');
  }

  public onRowAdd() {
    this.licenseModal.open(true, null, this.customer);
  }

  public onRowEdit(row: License) {
    this.licenseModal.open(false, row, this.customer);
  }

  public onRowDelete(row: License) {
    let message = `Czy na pewno usunąć licencję ${row.appName}?`;
    sweetAlert(message, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            if (row.id != null) {
              const action = this.rest.deleteLicense;
              action.call(this.rest, row.id).subscribe();
            }

            this.customer.licenses.splice(this.customer.licenses.indexOf(row), 1);
            this.grid.refreshData();
            break;
        }
      });
  }

  public onSuccessOperation(event) {
    if (event.isSuccess) {
      if (this.customer.id == 0) {
        event.license.id = (this.customer.licenses.length !== 0 ? Math.min.apply(Math, this.customer.licenses.map(function (o) { return o.id; })) : 0) - 1;
        this.customer.licenses.push(event.license);
      }
      else {
        event.license.customerId = this.customer.id;
        this.rest.saveLicense(event.license).subscribe((result: License) => {
          if (result && !this.customer.licenses.find(l => l.id == result.id)) {
            this.customer.licenses.push(result);
            this.grid.refreshData();
          }
        });
      }
    }
  }
}
